export default __webpack_public_path__ + "static/media/Avatar-28.7e96a159.png";